// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: FuturaLT;
}

.login_flexr__5QFaL,
.login_flexc__BBeng {
  justify-content: center;
  align-items: center;
  display: flex;
}
.login_flexc__BBeng {
  flex-direction: column;
}
.login_flexr__5QFaL {
  flex-direction: row;
}

.login_container__47xeI {
  width: 100%;
  min-height: 50vh;
  padding: 20px 10px;
}

.login_logintext__Vtifa {
  max-width: 400px;
  min-height: 500px;
  border-radius: 10px;
  padding: 10px 20px;
}

.login_logo__HstBV {
  margin-bottom: 20px;
}
.login_logo__HstBV span,
.login_logo__HstBV span i {
  font-size: 25px;
  color: #0d8aa7;
}

.login_login-text__3xLSq h1 {
  font-size: 25px;
}
.login_login-text__3xLSq p {
  font-size: 15px;
  color: #000000b2;
}

form {
  align-items: flex-start !important;
  width: 100%;
  margin-top: 15px;
}

.login_inputbox__-XFP5 {
  margin: 10px 0px;
  width: 100%;
  border-bottom: 0px;
}
.login_label__Sd9DS {
  font-size: 15px;
  color: black;
  margin-bottom: 3px;
}
.login_input__7ebE8 {
  display:flex ; 
  padding: 0px 5px;
  border: 1px solid;
  border-color: #000;
  border-radius: 12px;
 border-bottom-left-radius: 12px;
 border-bottom-right-radius: 12px;
  justify-content: flex-start;
}

input {
  border: none;
  outline: none;
  padding: 20px 5px;
  flex: 1 1;
}
.login_input__7ebE8 i {
  color: rgba(0, 0, 0, 0.4);
}

.login_check__FTJr\\+ span {
  color: #000000b2;
  font-size: 15px;
  font-weight: bold;
  margin-left: 5px;
}

.login_btn__gsIlu {
  color: #ffffff;
  border-radius: 30px;
  padding: 10px 15px;
  background: linear-gradient(122.33deg, #68bed1 30.62%, #1e94e9 100%);
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 16px;
  transition: all 0.3s linear;
}

.login_btn__gsIlu:hover {
  transform: translateY(-2px);
}
.login_extraline__HAgnH {
  font-size: 15px;
  font-weight: 600;
}
.login_extraline__HAgnH a {
  color: #0095b6;
}

.login_divider__PzCfe {
  width: 100%;
  height: 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  border: 1px solid var(--hsrcLightDark); }

.login_emailLink__ncFE3{
    font-size: 15px;
    color: var(--hsrcOrange);
    text-decoration: underline;
}

.login_buttonDiv__EZrhL {
width: 100%;
display: flex;
}



button {
display: inline-block;
    border-radius: 13px;
    background-color: var(--hsrcOrange);
    border-color: var(--hsrcOrange);
    border-style: solid;
    border-width: 1.5px;
    color: var(--hsrcWhite);
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    padding-left: 15px;
    transition: all 0.5s;
    margin: 15px;
    letter-spacing: 0.08rem;
    cursor: pointer;
    height: 70px;
    width: 150px;
    margin-left: auto;
}

h5 {
width: 100%;
}

input[type='text']{
border-style:none !important}

input::placeholder {
  overflow: visible;
}

.login_passwordToggle__75uIA{
margin-left:130px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/login.module.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB,+BAA+B;CAC/B,gCAAgC;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,SAAO;AACT;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;EACpE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC,EAAE;;AAE1C;IACI,eAAe;IACf,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;AACA,WAAW;AACX,aAAa;AACb;;;;AAIA;AACA,qBAAqB;IACjB,mBAAmB;IACnB,mCAAmC;IACnC,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,4BAA4B;;AAE5B;EACE,iBAAiB;AACnB;;AAEA;AACA,iBAAiB;AACjB","sourcesContent":["\r\n* {\r\n  margin: 0px;\r\n  padding: 0px;\r\n  box-sizing: border-box;\r\n  font-family: FuturaLT;\r\n}\r\n\r\n.flexr,\r\n.flexc {\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n}\r\n.flexc {\r\n  flex-direction: column;\r\n}\r\n.flexr {\r\n  flex-direction: row;\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  min-height: 50vh;\r\n  padding: 20px 10px;\r\n}\r\n\r\n.logintext {\r\n  max-width: 400px;\r\n  min-height: 500px;\r\n  border-radius: 10px;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.logo {\r\n  margin-bottom: 20px;\r\n}\r\n.logo span,\r\n.logo span i {\r\n  font-size: 25px;\r\n  color: #0d8aa7;\r\n}\r\n\r\n.login-text h1 {\r\n  font-size: 25px;\r\n}\r\n.login-text p {\r\n  font-size: 15px;\r\n  color: #000000b2;\r\n}\r\n\r\nform {\r\n  align-items: flex-start !important;\r\n  width: 100%;\r\n  margin-top: 15px;\r\n}\r\n\r\n.inputbox {\r\n  margin: 10px 0px;\r\n  width: 100%;\r\n  border-bottom: 0px;\r\n}\r\n.label {\r\n  font-size: 15px;\r\n  color: black;\r\n  margin-bottom: 3px;\r\n}\r\n.input {\r\n  display:flex ; \r\n  padding: 0px 5px;\r\n  border: 1px solid;\r\n  border-color: #000;\r\n  border-radius: 12px;\r\n border-bottom-left-radius: 12px;\r\n border-bottom-right-radius: 12px;\r\n  justify-content: flex-start;\r\n}\r\n\r\ninput {\r\n  border: none;\r\n  outline: none;\r\n  padding: 20px 5px;\r\n  flex: 1;\r\n}\r\n.input i {\r\n  color: rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.check span {\r\n  color: #000000b2;\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n  margin-left: 5px;\r\n}\r\n\r\n.btn {\r\n  color: #ffffff;\r\n  border-radius: 30px;\r\n  padding: 10px 15px;\r\n  background: linear-gradient(122.33deg, #68bed1 30.62%, #1e94e9 100%);\r\n  margin-top: 30px;\r\n  margin-bottom: 10px;\r\n  font-size: 16px;\r\n  transition: all 0.3s linear;\r\n}\r\n\r\n.btn:hover {\r\n  transform: translateY(-2px);\r\n}\r\n.extraline {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n.extraline a {\r\n  color: #0095b6;\r\n}\r\n\r\n.divider {\r\n  width: 100%;\r\n  height: 0px;\r\n  margin-top: 15px;\r\n  margin-bottom: 15px;\r\n  border: 1px solid var(--hsrcLightDark); }\r\n\r\n.emailLink{\r\n    font-size: 15px;\r\n    color: var(--hsrcOrange);\r\n    text-decoration: underline;\r\n}\r\n\r\n.buttonDiv {\r\nwidth: 100%;\r\ndisplay: flex;\r\n}\r\n\r\n\r\n\r\nbutton {\r\ndisplay: inline-block;\r\n    border-radius: 13px;\r\n    background-color: var(--hsrcOrange);\r\n    border-color: var(--hsrcOrange);\r\n    border-style: solid;\r\n    border-width: 1.5px;\r\n    color: var(--hsrcWhite);\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    padding-left: 15px;\r\n    transition: all 0.5s;\r\n    margin: 15px;\r\n    letter-spacing: 0.08rem;\r\n    cursor: pointer;\r\n    height: 70px;\r\n    width: 150px;\r\n    margin-left: auto;\r\n}\r\n\r\nh5 {\r\nwidth: 100%;\r\n}\r\n\r\ninput[type='text']{\r\nborder-style:none !important}\r\n\r\ninput::placeholder {\r\n  overflow: visible;\r\n}\r\n\r\n.passwordToggle{\r\nmargin-left:130px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexr": `login_flexr__5QFaL`,
	"flexc": `login_flexc__BBeng`,
	"container": `login_container__47xeI`,
	"logintext": `login_logintext__Vtifa`,
	"logo": `login_logo__HstBV`,
	"login-text": `login_login-text__3xLSq`,
	"inputbox": `login_inputbox__-XFP5`,
	"label": `login_label__Sd9DS`,
	"input": `login_input__7ebE8`,
	"check": `login_check__FTJr+`,
	"btn": `login_btn__gsIlu`,
	"extraline": `login_extraline__HAgnH`,
	"divider": `login_divider__PzCfe`,
	"emailLink": `login_emailLink__ncFE3`,
	"buttonDiv": `login_buttonDiv__EZrhL`,
	"passwordToggle": `login_passwordToggle__75uIA`
};
export default ___CSS_LOADER_EXPORT___;
